var _g, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: "100%",
      height: "100%"
    },
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    id: "svg12622770150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.666 8.333)",
    id: "ss12622770150_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.762 50 C 1.64 44.878 -0.008 38.994 0 32.995 C 0 14.773 14.924 0 33.333 0 C 51.743 0 66.667 14.773 66.667 32.995 C 66.667 39.216 64.927 45.035 61.905 50",
    fill: "#000000",
    strokeWidth: "4px",
    stroke: "#FFFCF5",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14.097 62.91 C 13.714 61.757 13.522 61.18 13.545 60.714 C 13.591 59.728 14.213 58.861 15.133 58.502 C 15.567 58.334 16.173 58.334 17.383 58.334 L 49.286 58.334 C 50.497 58.334 51.102 58.334 51.536 58.502 C 52.456 58.861 53.079 59.727 53.125 60.714 C 53.147 61.181 52.955 61.757 52.573 62.91 C 51.865 65.04 51.511 66.105 50.966 66.967 C 49.825 68.772 48.033 70.068 45.962 70.587 C 44.974 70.834 43.856 70.834 41.618 70.834 L 25.051 70.834 C 22.814 70.834 21.695 70.834 20.707 70.587 C 18.636 70.068 16.844 68.772 15.703 66.967 C 15.158 66.105 14.804 65.04 14.097 62.91 Z M 45.834 70.834 L 45.295 73.528 C 44.706 76.474 44.412 77.948 43.751 79.111 C 42.73 80.911 41.076 82.267 39.111 82.915 C 37.841 83.334 36.339 83.334 33.334 83.334 C 30.329 83.334 28.827 83.334 27.556 82.914 C 25.591 82.266 23.937 80.911 22.916 79.111 C 22.256 77.947 21.962 76.474 21.373 73.528 L 20.834 70.834",
    fill: "#000000",
    strokeWidth: "4px",
    stroke: "#FFFCF5",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 35.634 18.75 L 29.294 25.811 C 28.422 26.781 28.952 28.331 30.235 28.564 L 36.438 29.692 C 37.805 29.94 38.286 31.652 37.248 32.576 L 29.384 39.584",
    fill: "#000000",
    strokeWidth: "4px",
    stroke: "#FFFCF5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "",
    fillOpacity: 0
  }))))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#svg12622770150"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMr);
export default __webpack_public_path__ + "static/media/mr.9aff66b4679d696212e38739851ba6a9.svg";
export { ForwardRef as ReactComponent };